export const classes = {
  button:
    'flex h-[44px] items-center gap-[11px] px-3 rounded-[13px] text-[12.5px] font-semibold whitespace-nowrap select-none cursor-pointer transition-colors',
  active: 'bg-grad text-white shadow-[0_8px_16px_-6px_rgba(241,90,43,0.42)]',
  activeCustom: 'text-white shadow-[0_8px_16px_-6px_rgba(241,90,43,0.42)]',
  inactive: 'text-taupe-2 hover:bg-black/[0.08] hover:text-taupe-3',
  disabled: 'text-taupe-1/60 cursor-not-allowed',
  icon: 'flex-none place-center size-5',
  label:
    'max-w-0 opacity-0 overflow-hidden text-ellipsis transition-all duration-200 group-hover:max-w-[140px] group-hover:opacity-100',
};

export const styles = {
  active: (color?: string, bgColor?: string) => ({
    color: color || 'white',
    backgroundColor: bgColor,
  }),
};

export function isActive(href: string, path: string) {
  const hrefParts = href.toLowerCase().split('/');
  const pathParts = path.toLowerCase().split('/');
  return hrefParts.every((part, i) => part === pathParts[i]);
}

export function getStateClass(
  isButtonActive: boolean,
  hasCustomColor: boolean
) {
  if (!isButtonActive) return classes.inactive;
  return hasCustomColor ? classes.activeCustom : classes.active;
}
